import React, { useEffect, useRef, useState } from "react";
import Multiselect from "multiselect-react-dropdown";

import DropzoneThumbnail from "../../components/dropzone/DropzoneThumbnail";
import DropzoneVideo from "../../components/dropzone/DropzoneVideo";
import { useDropzone } from "react-dropzone";
import { VIDEO } from "../../components/image";
import { toast } from "react-toastify";
import StoriesService from "../../services/StoriesService";
import QuestionAnswersList from "./QuestionAnswersList";
import AddEditQuestions from "./AddEditQuestions";

const Questions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const [locations, setLocations] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [stories, setStories] = useState([]);

  const [activeQuestion, setActiveQuestion] = useState(false);
  const [activeStory, setActiveStory] = useState({});

  const [video, setVideo] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const uploadModalRef = useRef(null);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone();

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const handleIconClick = (mainIndex, subIndex) => {
    const key = `${mainIndex + 1} + ${subIndex + 1}`;
    if (key === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(key);
      setActiveStory(mainIndex);
    }
  };

  const getAllStories = async () => {
    try {
      const response = await StoriesService.getStories();
      if (response) {
        setStories(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteQuestion = async (mainIndex, subIndex) => {
    if (window.confirm("Do you really want to remove this question?")) {
      try {
        const data = {
          story: mainIndex,
          question: subIndex,
        };
        const response = null;

        if (response) {
          toast.success("Question delete successfully !");
          getQuestions();
          setActiveIndex("");
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const getQuestions = async () => {
    try {
      const response = null;
      if (response) {
        setQuestions(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllStories();
    getQuestions();
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex justify-content-between align-items-center">
        <div className="title">
          <ion-icon name="help-circle-outline"></ion-icon>
          <span className="text">Questions</span>
        </div>

        <button
          className="btn-header d-flex align-items-center gap-1"
          data-bs-target="#uploadModal"
          data-bs-toggle="modal"
          type="button"
        >
          <ion-icon name="add-outline"></ion-icon>
          Add
        </button>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                <th className="users-th">Title</th>
                <th className="users-th">Story</th>
                {/* <th className="users-th">Thumbnail</th> */}
                <th className="users-th">Video</th>
                <th className="users-th">Action</th>
              </tr>
            </thead>
            <tbody>
              {questions.map((item, i) => {
                return item.questions.map((question, index) => {
                  const key = `${i + 1} + ${index + 1}`;
                  return (
                    <tr key={index + i}>
                      <td className="users-td">
                        {i}.{index + 1}
                      </td>

                      <td className="users-td">{question.title}</td>
                      <td className="users-td">{item.story?.title}</td>
                      {/* <td className="users-td">
                        {
                          <img
                            height={70}
                            width={"auto"}
                            src={BASE_URL + question.thumbnail}
                          />
                        }
                      </td> */}
                      <td className="users-td">
                        <video width="100" height="100" controls>
                          <source
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </td>

                      <td className="users-td" style={{ width: "122px" }}>
                        <ion-icon
                          name="ellipsis-vertical-outline"
                          id="userAction"
                          onClick={() => handleIconClick(i, index)}
                          style={{ cursor: "pointer" }}
                        ></ion-icon>
                        {activeIndex === key && (
                          <div className="showOption-story">
                            <p
                              data-bs-target="#QuestionAnswersList"
                              data-bs-toggle="modal"
                              className="d-flex align-items-center gap-2 mt-2"
                              style={{ color: "black" }}
                              onClick={() => setActiveQuestion(question)}
                            >
                              <ion-icon name="bag-check-outline"></ion-icon>{" "}
                              Answers
                            </p>
                            <p
                              className="d-flex align-items-center gap-2"
                              data-bs-target="#editModal"
                              data-bs-toggle="modal"
                              onClick={() => setActiveQuestion(question)}
                            >
                              <ion-icon name="create-outline"></ion-icon> Edit
                            </p>
                            <p
                              className="d-flex align-items-center gap-2 mt-2"
                              style={{ color: "red" }}
                              onClick={() =>
                                deleteQuestion(item._id, question._id)
                              }
                            >
                              <ion-icon name="trash-outline"></ion-icon> Delete
                            </p>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>

          {/* QuestionAnswersList Model */}
          <div>
            <div
              className="modal fade"
              id="QuestionAnswersList"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1
                      className="modal-title fs-5"
                      id="exampleModalToggleLabel"
                    >
                      Answers
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <QuestionAnswersList question={activeQuestion._id} />
                  </div>
                  {/* <div className="modal-footer">
                    <button
                      className="btn-model"
                      data-bs-target="#exampleModalToggle2"
                      data-bs-toggle="modal"
                    >
                      Save Orders
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Edit Modal */}
          <div>
            <div
              className="modal fade"
              id="editModal"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
            >
              <AddEditQuestions
                type="edit"
                stories={stories}
                question={activeQuestion}
                activeStory={stories[activeStory]}
              />
            </div>
          </div>

          {/* Upload Modal */}
          <div>
            <div
              className="modal fade"
              id="uploadModal"
              aria-hidden="true"
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
              // ref={uploadModalRef}
            >
              <AddEditQuestions type="add" stories={stories} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Questions;
